import { LitElement, html, css } from '@hh/global.js'

export class HHClock extends LitElement {
  static properties = {
    label: {},
    timezone: {},
    time: { state: true },
    min: { state: true },
    sec: { state: true },
    hour: { state: true },
    valhour: { state: true },
    valminute: { state: true },
  }

  static styles = css`
    .clock-wrapper {
      display: inline-flex;
      flex-wrap: wrap;
      column-gap: 1rem;
      row-gap: 1rem;
      align-items: center;
    }

    .clock-body {
      height: 2.1rem;
      width: 2.1rem;
      border-radius: 50%;
      position: relative;
      border: 1.095px solid var(--watch-body);
    }

    .hand {
      background: var(--watch-hand);
      position: absolute;
      bottom: 50%;
      left: 50%;
      transform-origin: bottom;
      transition: all 0.05s;
      transition-timing-function: cubic-bezier(0.1, 2.7, 0.58, 1);
    }

    .second {
      background: var(--watch-second);
      width: 1.095px;
      height: 0.93rem;
      transform: translateX(-50%) rotate(0deg);
      z-index: 3;
    }

    .minute {
      height: 0.971rem;
      width: 1.095px;
      transform: translateX(-50%) rotate(0deg);
      background: var(--watch-hand);
      z-index: 2;
    }

    .hour {
      height: 0.528rem;
      width: 1.095px;
      background: var(--watch-hand);
      transform: translateX(-50%) rotate(0deg);
      z-index: 1;
    }

    .label {
      font-size: 1.2rem;
      line-height: 1.6rem;
      letter-spacing: 0.01em;
      font-weight: 300;
      min-width: 10rem;
    }

    :host([theme='footer']) .label {
      min-width: 0;
    }

    :host([theme='section']) .clock-wrapper {
      flex-direction: column;
      row-gap: 0.7rem;
    }

    :host([theme='section']) .label {
      font: var(--label-font);
      color: var(--watch-body);
    }

    :host([theme='section']) .clock-body {
      width: 3.034rem;
      height: 3.034rem;
      border-width: var(--border-width-mobile);
      box-sizing: border-box;
    }

    :host([theme='section']) .second,
    :host([theme='section']) .minute,
    :host([theme='section']) .hour {
      width: var(--border-width-mobile);
    }

    :host([theme='section']) .second {
      height: 1.224rem;
    }

    :host([theme='section']) .minute {
      height: 1.278rem;
    }

    :host([theme='section']) .hour {
      height: 0.695rem;
    }

    @media screen and (min-width: 1000px) {
      :host([theme='section']) .clock-wrapper {
        row-gap: 0.678rem;
      }

      :host([theme='section']) .clock-body {
        width: 3.679rem;
        height: 3.679rem;
        border-width: 2.1px;
      }

      :host([theme='section']) .second,
      :host([theme='section']) .minute,
      :host([theme='section']) .hour {
        width: var(--border-width);
      }

      :host([theme='section']) .second {
        height: 1.485rem;
      }

      :host([theme='section']) .minute {
        height: 1.55rem;
      }

      :host([theme='section']) .hour {
        height: 0.843rem;
      }
    }

    @media screen and (min-width: 1440px) {
      :host([theme='footer']) .label {
        min-width: 10rem;
      }
    }
  `

  connectedCallback() {
    super.connectedCallback()
    setInterval(this.startClock.bind(this), 1000)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    clearInterval(this.startClock)
  }

  firstUpdated() {
    this.time = this.renderRoot.querySelector('.hours')
    this.sec = this.renderRoot.querySelector('.second')
    this.min = this.renderRoot.querySelector('.minute')
    this.hour = this.renderRoot.querySelector('.hour')
  }

  render() {
    return html`
      <div class="clock-wrapper">
        <div
          class="clock-body"
          role="img"
          aria-label="${this.label + ' ' + this.valhour + ':' + this.valminute}"
        >
          <div class="hand second"></div>
          <div class="hand minute"></div>
          <div class="hand hour"></div>
        </div>

        <div class="label">
          <p>
            <span aria-hidden="true">${this.label}</span>
          </p>
        </div>
      </div>
    `
  }

  startClock() {
    const local = new Date().toLocaleString('en-US', {
      timeZone: this.timezone,
    })
    const now = new Date(local)
    const seconds = now.getSeconds()
    const minutes = now.getMinutes()
    const hours = now.getHours()

    let secDeg = seconds * (360 / 60) + minutes * 360
    let minDeg = minutes * (360 / 60) + seconds / 12
    let hourDeg = hours * (360 / 12) + (minutes / 12) * (360 / 60)

    this.valhour = ('0' + hours).slice(-2)
    this.valminute = ('0' + minutes).slice(-2)

    this.sec.style.transform = `translateX(-50%) rotate(${secDeg}deg)`
    this.min.style.transform = `translateX(-50%) rotate(${minDeg}deg)`
    this.hour.style.transform = `translateX(-50%) rotate(${hourDeg}deg)`
  }
}

customElements.define('hh-clock', HHClock)
